import { useQuery } from '@apollo/client'
import { useLocation } from 'react-router-dom'
import { Box, Heading } from 'rebass/styled-components'

import { PRIVACY_POLICY } from '../../graphql/queries'
import { IonPage, IonLoading } from '@ionic/react'
import Header from '../../components/Header'
import IonContent from '../../components/IonContent'

export default () => {
    const { search } = useLocation()
    const { data, loading } = useQuery(PRIVACY_POLICY)
    const type = search?.includes('terms') ? 'termsOfService' : 'privacyPolicy'
    const info = data?.shop[type]
    return (
        <IonPage>
            <Header title={info?.title}></Header>
            <IonContent fullscreen>
                <Box px="20px" bg="#fff" dangerouslySetInnerHTML={{ __html: info?.body }}></Box>
                <IonLoading isOpen={loading}></IonLoading>
            </IonContent>
        </IonPage>
    )
}
